import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 85,
    height: 85
  },
  name: {
    marginTop: theme.spacing(1),
    paddingBottom: '15px',
    fontSize: '22px',
    color: '#fcfcfc',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(',')
  },
  description: {
    paddingTop: '15px',
    textAlign: 'center',
    fontSize: '15px',
    color: '#fcfcfc'
  }
}));

const Profile = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography
        className={classes.name}
        variant="h4"
      >
        Davi Baltar
      </Typography>
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src='/images/avatars/avatar_0.jpeg'
        to='/aboutme'
      />
      <Typography variant="body2" className={classes.description}>Hi, my name is Davi Baltar and I'm a Full Stack developer. Welcome to my personal website!</Typography>
    </div>
  );
};

export default Profile;
